import { useEffect, useRef } from "react";
import { ReviewDecisionStatus, AssessmentStatus } from "../../../../../utils/enums";

export const useAutoSave = ({
  decisions,
  commentsByUser,
  users,
  currentAssessment,
  mutateUpdateAssessment,
}) => {
  const timeoutRef = useRef(null);
  const prevDecisionsRef = useRef({});
  const prevCommentsRef = useRef({});

  useEffect(() => {
    if (!currentAssessment || currentAssessment?.status_title?.toLowerCase() !== AssessmentStatus.DRAFT) {
      return;
    }

    const decisionsChanged = JSON.stringify(decisions) !== JSON.stringify(prevDecisionsRef.current);
    const commentsChanged = JSON.stringify(commentsByUser) !== JSON.stringify(prevCommentsRef.current);

    if (!decisionsChanged && !commentsChanged) {
      return;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(async () => {
      try {
        const userUpdates = users.map((user) => {
          const update = {
            user_id: user.id,
            review_status: decisions[user.id] || ReviewDecisionStatus.APPROVED,
          };
          if (commentsByUser[user.id]) {
            update.review_note = commentsByUser[user.id];
          }
          return update;
        });

        await mutateUpdateAssessment({
          variables: {
            input: [
              {
                id: currentAssessment.id,
                user_updates: userUpdates,
              },
            ],
          },
        });

        prevDecisionsRef.current = { ...decisions };
        prevCommentsRef.current = { ...commentsByUser };
      } catch (error) {
        console.error("Auto-save failed:", error);
      }
    }, 1000); 

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [decisions, commentsByUser, users, currentAssessment, mutateUpdateAssessment]);
};

